import { render, staticRenderFns } from "./BuildingCreate.vue?vue&type=template&id=3b374cb5"
import script from "./BuildingCreate.vue?vue&type=script&lang=ts"
export * from "./BuildingCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports